import * as React from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import styled, { css } from "~/styled";

const Typography = styled.p<{ organization: string }>`
  font-size: 14px;
  margin-top: 8px;

  ${props =>
    props.organization === "emerchant" &&
    css`
      &::before {
        content: "📞";
      }
    `}

  @media (max-width: 375px) {
    font-size: 12px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
  }
`;

class PhoneNumber extends React.Component<WithTranslation> {
  public render() {
    const { t } = this.props;
    const { organization, organizationPhoneNumber } = shopConfig;

    if (!organizationPhoneNumber || organizationPhoneNumber === "") {
      return null;
    }

    return (
      <Callout
        title={t("footer.phone.title")}
        intent={organization === "emerchant" ? "primary" : "none"}
        icon={null}
      >
        <Typography
          organization={organization}
          dangerouslySetInnerHTML={{
            __html: t("footer.phone.description", {
              phone: organizationPhoneNumber
            })
          }}
        />
      </Callout>
    );
  }
}

export default withTranslation("general")(PhoneNumber);



// WEBPACK FOOTER //
// ./src/components/Legal/PhoneNumber.tsx